import { useContext, useEffect } from "react";
import { GlobalInfo } from "../../Contexts/GlobalContext";
import { useLocation, useNavigate } from "react-router-dom";
import AdministrativeSettingsMenu from "./AdministrativeSettings/AdministrativeSettingsMenu";
import TokenService from '../../Services/Token.service';
import { Helmet } from "react-helmet";
function AdministrativeSettings() {

    const location = useLocation();
    const { children = [] } = location.state || {};
     
    useEffect(()=>{
         
    },[]);
    const { isSidebarVisible } = useContext(GlobalInfo);
    const menus = TokenService.getAdministratorMenu();
    return (
        <>
         <Helmet>
            <title>DonorX | Administrative Settings</title>
        </Helmet>
            {/* <div className={`el-middle ${!isSidebarVisible ? 'collapsed-body' : ''}`}> */}
            <div className="el-middle-wrapper">
                <h2 className="el-title">Administrative Settings</h2>
                <div className="row justify-content-start">

                    <AdministrativeSettingsMenu children={menus} />
                </div>
            </div>
            {/* </div> */}
        </>
    );

}

export default AdministrativeSettings;